import {useEffect} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";

const AttendanceQualityCards = ({data}) => {
  useEffect(() => {
    const summaryLabels = [
      "Total de atendimentos",
      "Incompletos",
      "Completos",
    ];

    const summaryValues = [
      data?.total ?? 0,
      data?.incomplete ?? 0,
      data?.complete ?? 0
    ];

    ReportUtils.createExportableTable(summaryLabels, summaryValues, "Cards");
  }, [data]);

  return (
    <>
      <div className="grid grid-cols-3 gap-2">
        <div className="text-center">
          <div className="box" id="boxCount">
            <h3>Total de atendimentos</h3> <h2>{data?.total ?? 0}</h2>
          </div>
        </div>

        <div className="text-center">
          <div className="box" id="boxCount">
            <h3>Incompletos</h3> <h2>{data?.incomplete ?? 0}</h2>
          </div>
        </div>

        <div className="text-center">
          <div className="box" id="boxCount">
            <h3>Completos (%)</h3> <h2>{data?.complete ?? 0}</h2>
          </div>
        </div>
      </div>

      <div className="chart-divisor"></div>

    </>
  )
}

export default  AttendanceQualityCards;